import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import DateTimeFormats from "const/DateTimeFormats";
import FieldContainer from "../FieldContainer";
import React, { useMemo } from "react";
import moment from "moment";
import useDocumentContext from "hooks/useDocumentContext";

const PairedTransactionsField = (props) => {
  const id = "pairedTransactions";

  const { uiTexts } = useSelector(getTextsData);

  const {
    documentData: { paidTransactions = [], matchedTransactions = 0 },
    documentState: { paid, amount: documentAmount },
    onPairedTransactionClick
  } = useDocumentContext();

  const fieldValue = useMemo(() => {
    if (paidTransactions.length) {
      return paidTransactions.map((transaction) => {
        const { timestamp, amount, currency, extra = {}, description = "" } = transaction;

        return [moment(timestamp).format(DateTimeFormats.DATE_TEXT),
          `${amount} ${currency}`,
          transaction.address && transaction.address.name,
          extra.VS && `VS ${extra.VS}`,
          extra.KS && `KS ${extra.KS}`,
          extra.SS && `SS ${extra.SS}`,
          description].filter(Boolean).join(", ");
      }).join("; ");
    }
    if (matchedTransactions) {
      return `${uiTexts.matching}: ${matchedTransactions}`;
    }

    return null;
  }, [matchedTransactions, paidTransactions, uiTexts]);

  const transactionsAmount = useMemo(() => {
    return paidTransactions.reduce((acc, transaction) => {
      return acc + transaction.amount;
    }, 0);
  }, [paidTransactions]);

  return (
    <FieldContainer
      id={id}
      disabled={paid}
      label={uiTexts.pairedTransactions}
      invalid={(!!paidTransactions.length && (transactionsAmount !== documentAmount))}
      displayValue={fieldValue || uiTexts.noTransactionsFound}
      onClick={onPairedTransactionClick}
      {...props} />
  );
};

export default React.memo(PairedTransactionsField);
